{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Coller",
    "pasteAsPlaintext": "Coller comme texte brut",
    "pasteCharts": "Coller les graphiques",
    "chartType_bar": "Graphique à barres",
    "chartType_line": "Courbes",
    "chartType_radar": "Diagramme en radar",
    "chartType_plaintext": "Texte brut",
    "selectAll": "Tout sélectionner",
    "multiSelect": "Ajouter l'élément à la sélection",
    "moveCanvas": "Déplacer le canevas",
    "cut": "Couper",
    "copy": "Copier",
    "copyAsPng": "Copier dans le presse-papier en PNG",
    "copyAsSvg": "Copier dans le presse-papier en SVG",
    "copyText": "Copier dans le presse-papier en tant que texte",
    "copySource": "Copier la source dans le presse-papiers",
    "convertToCode": "Convertir en code",
    "bringForward": "Envoyer vers l'avant",
    "sendToBack": "Déplacer à l'arrière-plan",
    "bringToFront": "Mettre au premier plan",
    "sendBackward": "Reculer d'un plan",
    "delete": "Supprimer",
    "copyStyles": "Copier les styles",
    "pasteStyles": "Coller les styles",
    "stroke": "Trait",
    "changeStroke": "Changer la couleur du trait",
    "background": "Arrière-plan",
    "changeBackground": "Changer la couleur d'arrière-plan",
    "fill": "Remplissage",
    "strokeWidth": "Largeur du contour",
    "strokeStyle": "Style du trait",
    "strokeStyle_solid": "Continu",
    "strokeStyle_dashed": "Tirets",
    "strokeStyle_dotted": "Pointillés",
    "sloppiness": "Style de tracé",
    "pressure": "Pression",
    "pressure_constant": "Constant",
    "pressure_variable": "Variable",
    "opacity": "Transparence",
    "textAlign": "Alignement du texte",
    "edges": "Angles",
    "sharp": "Pointus",
    "round": "Arrondis",
    "arrowheads": "Extrémités",
    "arrowhead_none": "Sans",
    "arrowhead_arrow": "Flèche",
    "arrowhead_bar": "Barre",
    "arrowhead_circle": "Cercle",
    "arrowhead_circle_outline": "Cercle (contour)",
    "arrowhead_triangle": "Triangle",
    "arrowhead_triangle_outline": "Triangle (contour)",
    "arrowhead_diamond": "Losange",
    "arrowhead_diamond_outline": "Losange (contour)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "Pied de Corde (un)",
    "arrowhead_crowfoot_one_or_many": "Pied du corbeau (un ou plusieurs)",
    "arrowhead_cardinality_one": "Cardinalité (une)",
    "arrowhead_cardinality_many": "Cardinalité (plusieurs)",
    "arrowhead_cardinality_one_or_many": "Cardinalité (une ou plusieurs)",
    "arrowhead_cardinality_exactly_one": "Cardinalité (exactement une)",
    "arrowhead_cardinality_zero_or_one": "Cardinalité (zéro ou une)",
    "arrowhead_cardinality_zero_or_many": "Cardinalité (zéro ou plusieurs)",
    "more_options": "Plus d'options",
    "cardinality": "Cardinalité",
    "arrowtypes": "Type de flèche",
    "arrowtype_sharp": "Flèche pointue",
    "arrowtype_round": "Flèche incurvée",
    "arrowtype_elbowed": "Flèche coudée",
    "fontSize": "Taille de la police",
    "fontFamily": "Police",
    "addWatermark": "Ajouter \"Réalisé avec Excalidraw\"",
    "handDrawn": "À main levée",
    "normal": "Normale",
    "code": "Code",
    "small": "Petite",
    "medium": "Moyenne",
    "large": "Grande",
    "veryLarge": "Très grande",
    "solid": "Solide",
    "hachure": "Hachures",
    "zigzag": "Zigzag",
    "crossHatch": "Hachures croisées",
    "thin": "Fine",
    "bold": "Épaisse",
    "left": "À gauche",
    "center": "Au centre",
    "right": "À droite",
    "extraBold": "Très épaisse",
    "architect": "Architecte",
    "artist": "Artiste",
    "cartoonist": "Caricaturiste",
    "fileTitle": "Nom du fichier",
    "colorPicker": "Sélecteur de couleur",
    "canvasColors": "Utilisé sur la zone de dessin",
    "canvasBackground": "Arrière-plan du canevas",
    "drawingCanvas": "Zone de dessin",
    "clearCanvas": "Effacer la zone de dessin",
    "layers": "Disposition",
    "actions": "Actions",
    "language": "Langue",
    "liveCollaboration": "Collaboration en direct...",
    "duplicateSelection": "Dupliquer",
    "untitled": "Sans-titre",
    "name": "Nom",
    "yourName": "Votre nom",
    "madeWithExcalidraw": "Fait avec Excalidraw",
    "group": "Grouper la sélection",
    "ungroup": "Dégrouper la sélection",
    "collaborators": "Collaborateurs",
    "you": "Vous",
    "toggleGrid": "Afficher/Cacher la grille",
    "loadingScene": "Chargement de la scène…",
    "loadScene": "Charger une scène depuis un fichier",
    "align": "Alignement",
    "alignTop": "Aligner en haut",
    "alignBottom": "Aligner en bas",
    "alignLeft": "Aligner à gauche",
    "alignRight": "Aligner à droite",
    "centerVertically": "Centrer verticalement",
    "centerHorizontally": "Centrer horizontalement",
    "distributeHorizontally": "Répartir horizontalement",
    "distributeVertically": "Répartir verticalement",
    "flipHorizontal": "Retourner horizontalement",
    "flipVertical": "Retourner verticalement",
    "viewMode": "Mode présentation",
    "share": "Partager",
    "showStroke": "Afficher le sélecteur de couleur de trait",
    "showBackground": "Afficher le sélecteur de couleur de fond",
    "showFonts": "Afficher le sélecteur de polices",
    "toggleTheme": "Basculer mode clair/sombre",
    "theme": "Thème",
    "decreaseFontSize": "Diminuer la taille de police",
    "increaseFontSize": "Augmenter la taille de la police",
    "unbindText": "Dissocier le texte",
    "bindText": "Associer le texte au conteneur",
    "createContainerFromText": "Encadrer le texte dans un conteneur",
    "link": {
      "edit": "Modifier le lien",
      "editEmbed": "Editer le lien intégrable",
      "create": "Ajouter un lien",
      "label": "Lien",
      "labelEmbed": "Lier & intégrer",
      "empty": "Aucun lien défini",
      "hint": "Tapez ou collez votre lien ici",
      "goToElement": "Aller à l'élément cible"
    },
    "lineEditor": {
      "edit": "Modifier la ligne",
      "editArrow": "Modifier la flèche"
    },
    "polygon": {
      "breakPolygon": "Briser le polygone",
      "convertToPolygon": "Convertir en polygone"
    },
    "elementLock": {
      "lock": "Verrouiller",
      "unlock": "Déverrouiller",
      "lockAll": "Tout verrouiller",
      "unlockAll": "Tout déverrouiller"
    },
    "sidebarLock": "Maintenir la barre latérale ouverte",
    "selectAllElementsInFrame": "Sélectionner tous les éléments du cadre",
    "removeAllElementsFromFrame": "Supprimer tous les éléments du cadre",
    "eyeDropper": "Choisir la couleur depuis le canevas",
    "followUs": "Suivez-nous",
    "discordChat": "Salon Discord",
    "zoomToFitViewport": "Zoomer pour tenir dans la fenêtre d'affichage",
    "zoomToFitSelection": "Zoomer pour s'adapter à la sélection",
    "zoomToFit": "Zoomer pour voir tous les éléments",
    "installPWA": "Installer Excalidraw localement (PWA)",
    "autoResize": "Activer le redimensionnement automatique du texte",
    "imageCropping": "Recadrage de l'image",
    "unCroppedDimension": "Dimension non recadrée",
    "copyElementLink": "Copier le lien vers un objet",
    "linkToElement": "Lien vers un objet",
    "wrapSelectionInFrame": "Mettre la sélection dans un cadre",
    "tab": "Onglet",
    "shapeSwitch": "Changer de forme",
    "preferences": "Préférences",
    "preferences_toolLock": "Verrouillage de l'outil",
    "boxSelectionMode": "Sélectionner sur",
    "boxSelectionContain": "Mettre en page",
    "boxSelectionOverlap": "Chevaucher",
    "arrowBinding": "Liaison de flèches",
    "midpointSnapping": "S'accrocher aux points intermédiaires"
  },
  "elementLink": {
    "title": "Lien vers un objet",
    "desc": "Cliquez sur une forme sur le canvas ou collez un lien.",
    "notFound": "L'objet lié n'a pas été trouvé sur le canvas."
  },
  "search": {
    "title": "Rechercher sur le canevas",
    "noMatch": "Aucun résultat trouvé...",
    "singleResult": "résultat",
    "multipleResults": "résultats",
    "placeholder": "Rechercher du texte sur la toile...",
    "frames": "Cadres",
    "texts": "Textes"
  },
  "buttons": {
    "clearReset": "Réinitialiser le canevas",
    "exportJSON": "Exporter comme fichier",
    "exportImage": "Exporter l'image...",
    "export": "Enregistrer sous...",
    "copyToClipboard": "Copier dans le presse-papier",
    "copyLink": "",
    "save": "Enregistrer dans le fichier actuel",
    "saveAs": "Enregistrer sous",
    "load": "Ouvrir",
    "getShareableLink": "Obtenir un lien de partage",
    "close": "Fermer",
    "selectLanguage": "Choisir une langue",
    "scrollBackToContent": "Revenir au contenu",
    "zoomIn": "Zoomer",
    "zoomOut": "Dézoomer",
    "resetZoom": "Réinitialiser le zoom",
    "menu": "Menu",
    "done": "Terminé",
    "edit": "Modifier",
    "undo": "Annuler",
    "redo": "Rétablir",
    "createNewRoom": "Créer une nouvelle salle",
    "fullScreen": "Plein écran",
    "darkMode": "Mode sombre",
    "lightMode": "Mode clair",
    "systemMode": "Mode système",
    "zenMode": "Mode zen",
    "objectsSnapMode": "Aimanter aux objets",
    "exitZenMode": "Quitter le mode zen",
    "cancel": "Annuler",
    "clear": "Effacer",
    "remove": "Supprimer",
    "embed": "Activer/Désactiver l'intégration",
    "submit": "Envoyer",
    "confirm": "Confirmer",
    "embeddableInteractionButton": "Cliquez pour interagir"
  },
  "alerts": {
    "clearReset": "L'intégralité du canevas va être effacée. Êtes-vous sûr ?",
    "couldNotCreateShareableLink": "Impossible de créer un lien de partage.",
    "couldNotCreateShareableLinkTooBig": "Impossible de créer un lien de partage : la scène est trop volumineuse",
    "couldNotLoadInvalidFile": "Impossible de charger un fichier invalide",
    "importBackendFailed": "L'importation depuis le serveur a échoué.",
    "cannotExportEmptyCanvas": "Impossible d'exporter un canevas vide.",
    "couldNotCopyToClipboard": "Impossible de copier dans le presse-papiers.",
    "decryptFailed": "Les données n'ont pas pu être déchiffrées.",
    "uploadedSecurly": "Le téléchargement a été sécurisé avec un chiffrement de bout en bout, ce qui signifie que ni Excalidraw ni personne d'autre ne peut en lire le contenu.",
    "loadSceneOverridePrompt": "Le chargement d'un dessin externe remplacera votre contenu actuel. Souhaitez-vous continuer ?",
    "collabStopOverridePrompt": "Arrêter la session écrasera votre précédent dessin stocké localement. Êtes-vous sûr·e ?\n\n(Si vous voulez garder votre dessin local, fermez simplement l'onglet du navigateur à la place.)",
    "imageDoesNotContainScene": "Cette image ne semble pas contenir de données de scène. Avez-vous activé l'intégration de scène lors de l'exportation ?",
    "cannotRestoreFromImage": "Impossible de restaurer la scène depuis ce fichier image",
    "invalidSceneUrl": "Impossible d'importer la scène depuis l'URL fournie. Elle est soit incorrecte, soit ne contient pas de données JSON Excalidraw valides.",
    "invalidEncryptionKey": "La clé de chiffrement doit comporter 22 caractères. La collaboration en direct est désactivée.",
    "collabOfflineWarning": "Aucune connexion internet disponible.\nVos modifications ne seront pas enregistrées !",
    "localStorageQuotaExceeded": "Quota de stockage du navigateur dépassé. Les modifications ne seront pas enregistrées."
  },
  "errors": {
    "unsupportedFileType": "Type de fichier non supporté.",
    "imageInsertError": "Impossible d'insérer l'image. Réessayez plus tard...",
    "fileTooBig": "Le fichier est trop volumineux. La taille maximale autorisée est de {{maxSize}}.",
    "svgImageInsertError": "Impossible d'insérer l'image SVG. Le balisage SVG semble invalide.",
    "failedToFetchImage": "Échec de récupération de l'image.",
    "cannotResolveCollabServer": "Impossible de se connecter au serveur collaboratif. Veuillez recharger la page et réessayer.",
    "collabSaveFailed": "Impossible d'enregistrer dans la base de données en arrière-plan. Si des problèmes persistent, vous devriez enregistrer votre fichier localement pour vous assurer de ne pas perdre votre travail.",
    "collabSaveFailed_sizeExceeded": "Impossible d'enregistrer dans la base de données en arrière-plan, le tableau semble trop grand. Vous devriez enregistrer le fichier localement pour vous assurer de ne pas perdre votre travail.",
    "imageToolNotSupported": "Les images sont désactivées.",
    "brave_measure_text_error": {
      "line1": "On dirait que vous utilisez le navigateur Brave avec l'option <bold>Bloquer agressivement le fichage</bold> activée.",
      "line2": "Cela pourrait entraîner des problèmes avec les <bold>Éléments Textuels</bold> dans vos dessins.",
      "line3": "Nous recommandons fortement de désactiver cette option. Vous pouvez suivre <link>ces instructions</link> pour savoir comment faire.",
      "line4": "Si désactiver cette option de résout pas le problème d'affichage des éléments textuels, veuillez ouvrir un <issueLink>ticket</issueLink> sur notre GitHub, ou écrivez-nous sur notre <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "Impossible de coller (impossible de lire le presse-papiers système).",
    "asyncPasteFailedOnParse": "Impossible de coller.",
    "copyToSystemClipboardFailed": "Échec de la copie dans le presse-papiers."
  },
  "toolBar": {
    "selection": "Sélection",
    "lasso": "Sélection lasso",
    "image": "Insérer une image",
    "rectangle": "Rectangle",
    "diamond": "Losange",
    "ellipse": "Ellipse",
    "arrow": "Flèche",
    "line": "Ligne",
    "freedraw": "Dessiner",
    "text": "Texte",
    "lock": "Garder l'outil sélectionné actif après le dessin",
    "penMode": "Mode stylo - évite le toucher",
    "link": "Ajouter / Mettre à jour un lien pour une forme sélectionnée",
    "eraser": "Gomme",
    "frame": "Outil de cadre",
    "embeddable": "Intégration Web",
    "laser": "Pointeur laser",
    "autoshape": "Dessiner pour façonner",
    "bucketfill": "Remplissage du seau",
    "hand": "Mains (outil de déplacement de la vue)",
    "extraTools": "Plus d'outils",
    "convertElementType": "Basculer le type de forme"
  },
  "bucketfill": {
    "noRegion": "Impossible de trouver une région à remplir ici.",
    "tooComplex": "Cette région est trop complexe à remplir."
  },
  "element": {
    "rectangle": "Rectangle",
    "diamond": "Losange",
    "ellipse": "Ellipse",
    "arrow": "Flèche",
    "line": "Ligne",
    "freedraw": "Dessin libre",
    "text": "Texte",
    "image": "Image",
    "group": "Groupe",
    "frame": "Cadre",
    "embeddable": "Intégration Web",
    "selection": "Sélection",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Actions du canevas",
    "selectedShapeActions": "Actions pour la forme sélectionnée",
    "shapes": "Formes"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} pour fermer la recherche",
    "canvasPanning": "Pour déplacer le canevas, maintenez {{shortcut_1}} ou {{shortcut_2}} enfoncé tout en faisant glisser, ou utilisez l'outil main",
    "linearElement": "Cliquez pour démarrer plusieurs points, faites glisser pour une seule ligne",
    "arrowTool": "Cliquez pour démarrer plusieurs points, faites glisser pour une ligne unique. Appuyez à nouveau sur {{shortcut}} pour changer le type de flèche.",
    "arrowBindModifiers": "Maintenez {{shortcut_1}} pour désactiver la liaison, ou {{shortcut_2}} pour se lier à un point fixe",
    "freeDraw": "Cliquez et faites glissez, relâchez quand vous avez terminé",
    "text": "Astuce : vous pouvez aussi ajouter du texte en double-cliquant n'importe où avec l'outil de sélection",
    "embeddable": "Cliquez et glissez pour créer une intégration de site web",
    "autoshape": "Dessiner des rectangles, des cercles, des diamants, des lignes et des flèches",
    "text_selected": "Double-cliquez ou appuyez sur {{shortcut}} pour modifier le texte",
    "text_editing": "Appuyez sur {{shortcut_1}} ou {{shortcut_2}} pour terminer la modification",
    "linearElementMulti": "Cliquez sur le dernier point ou appuyez sur {{shortcut_1}} ou {{shortcut_2}} pour terminer",
    "lockAngle": "Vous pouvez limiter l'angle en maintenant la touche {{shortcut}} enfoncée",
    "resize": "Vous pouvez contraindre les proportions en maintenant {{shortcut_1}} pendant le redimensionnement,\nmaintenez {{shortcut_2}} enfoncé pour redimensionner depuis le centre",
    "resizeImage": "Vous pouvez redimensionner librement en maintenant {{shortcut_1}},\nmaintenez {{shortcut_2}} enfoncé pour redimensionner depuis le centre",
    "rotate": "Vous pouvez contraindre les angles en maintenant {{shortcut}} enfoncé pendant la rotation",
    "toggleArrowhead": "Double-cliquez pour basculer la tête de flèche",
    "lineEditor_info": "Maintenez {{shortcut_1}} et Double-cliquez ou appuyez sur {{shortcut_2}} pour modifier les points",
    "lineEditor_line_info": "Double-cliquez ou appuyez sur {{shortcut}} pour modifier le texte",
    "lineEditor_pointSelected": "Appuyez sur {{shortcut_1}} pour supprimer le(s) point(s),\n{{shortcut_2}} pour dupliquer, ou faites glisser pour déplacer",
    "lineEditor_nothingSelected": "Sélectionnez un point à éditer (maintenez {{shortcut_1}} enfoncé pour en sélectionner plusieurs),\nou maintenez {{shortcut_2}} et cliquez pour ajouter de nouveaux points",
    "bindTextToElement": "{{shortcut}} pour ajouter du texte",
    "createFlowchart": "{{shortcut}} pour créer un diagramme",
    "deepBoxSelect": "Maintenez {{shortcut}} enfoncé pour sélectionner en profondeur, et pour éviter le glissement",
    "eraserRevert": "Maintenez {{shortcut}} pour annuler les éléments marqués pour suppression",
    "firefox_clipboard_write": "Cette fonctionnalité devrait pouvoir être activée en définissant l'option \"dom.events.asyncClipboard.clipboard.clipboardItem\" à \"true\". Pour modifier les paramètres du navigateur dans Firefox, visitez la page \"about:config\".",
    "disableSnapping": "Maintenez {{shortcut}} pour désactiver l'accrochage",
    "enterCropEditor": "Double-cliquez sur l'image ou appuyez sur {{shortcut}} pour recadrer l'image",
    "leaveCropEditor": "Cliquez à l'extérieur de l'image ou appuyez sur {{shortcut_1}} ou {{shortcut_2}} pour terminer le recadrage"
  },
  "canvasError": {
    "cannotShowPreview": "Impossible d’afficher l’aperçu",
    "canvasTooBig": "Le canevas est peut-être trop grand.",
    "canvasTooBigTip": "Astuce : essayez de rapprocher un peu les éléments les plus éloignés."
  },
  "errorSplash": {
    "headingMain": "Une erreur est survenue. Essayez <button>de recharger la page.</button>",
    "clearCanvasMessage": "Si le rechargement ne résout pas l'erreur, essayez <button>effacement du canevas.</button>",
    "clearCanvasCaveat": " Cela entraînera une perte du travail ",
    "trackedToSentry": "L'erreur avec l'identifiant {{eventId}} a été enregistrée dans notre système.",
    "openIssueMessage": "Nous avons fait très attention à ne pas inclure les informations de votre scène dans l'erreur. Si votre scène n'est pas privée, veuillez envisager de poursuivre sur notre <button>outil de suivi des bugs.</button> Veuillez inclure les informations ci-dessous en les copiant-collant dans le ticket GitHub.",
    "sceneContent": "Contenu de la scène :"
  },
  "shareDialog": {
    "or": "Ou"
  },
  "roomDialog": {
    "desc_intro": "Invitez des personnes à collaborer sur votre dessin.",
    "desc_privacy": "Ne vous inquiétez pas, la session est chiffrée de bout en bout et entièrement privée. Même notre serveur ne peut pas voir ce que vous dessinez.",
    "button_startSession": "Démarrer la session",
    "button_stopSession": "Arrêter la session",
    "desc_inProgressIntro": "La session de collaboration en direct est maintenant en cours.",
    "desc_shareLink": "Partagez ce lien avec les personnes avec lesquelles vous souhaitez collaborer :",
    "desc_exitSession": "Arrêter la session vous déconnectera de la salle, mais vous pourrez continuer à travailler avec la scène, localement. Notez que cela n'affectera pas les autres personnes, et ils pourront toujours collaborer sur leur version.",
    "shareTitle": "Rejoindre une session de collaboration en direct sur Excalidraw"
  },
  "errorDialog": {
    "title": "Erreur"
  },
  "progressDialog": {
    "title": "Enregistrement",
    "defaultMessage": "Préparation de l'enregistrement..."
  },
  "exportDialog": {
    "disk_title": "Enregistrer sur le disque",
    "disk_details": "Exporter les données de la scène comme un fichier que vous pourrez importer ultérieurement.",
    "disk_button": "Enregistrer comme fichier",
    "link_title": "Lien partageable",
    "link_details": "Exporter comme un lien en lecture seule.",
    "link_button": "Exporter comme lien",
    "excalidrawplus_description": "Enregistrer la scène dans votre espace de travail Excalidraw+.",
    "excalidrawplus_button": "Exporter",
    "excalidrawplus_exportError": "Impossible d'exporter vers Excalidraw+ pour le moment..."
  },
  "helpDialog": {
    "blog": "Lire notre blog",
    "click": "clic",
    "deepSelect": "Sélection dans les groupes",
    "deepBoxSelect": "Sélectionner dans les groupes, et empêcher le déplacement",
    "createFlowchart": "Créer un diagramme à partir d'un élément",
    "navigateFlowchart": "",
    "curvedArrow": "Flèche courbée",
    "curvedLine": "Ligne courbée",
    "documentation": "Documentation",
    "doubleClick": "double-clic",
    "drag": "glisser",
    "editor": "Éditeur",
    "editLineArrowPoints": "Modifier les points de ligne/flèche",
    "editText": "Modifier le texte / ajouter un libellé",
    "github": "Problème trouvé ? Soumettre",
    "howto": "Suivez nos guides",
    "or": "ou",
    "preventBinding": "Empêcher la liaison de flèche",
    "tools": "Outils",
    "shortcuts": "Raccourcis clavier",
    "textFinish": "Terminer l'édition (éditeur de texte)",
    "textNewLine": "Ajouter une nouvelle ligne (éditeur de texte)",
    "title": "Aide",
    "view": "Affichage",
    "zoomToFit": "Zoomer pour voir tous les éléments",
    "zoomToSelection": "Zoomer sur la sélection",
    "toggleElementLock": "Verrouiller/déverrouiller la sélection",
    "movePageUpDown": "Déplacer la page vers le haut/bas",
    "movePageLeftRight": "Déplacer la page vers la gauche/droite",
    "cropStart": "Rogner l’image",
    "cropFinish": "Terminer le recadrage de l'image"
  },
  "clearCanvasDialog": {
    "title": "Effacer la zone de dessin"
  },
  "imageExportDialog": {
    "header": "Exporter l'image",
    "label": {
      "withBackground": "Fond",
      "onlySelected": "Uniquement la sélection",
      "darkMode": "Mode sombre",
      "embedScene": "Intégrer la scène",
      "scale": "Échelle",
      "padding": "Marge interne"
    },
    "tooltip": {
      "embedScene": "Les données de la scène seront sauvegardées dans le fichier PNG/SVG exporté afin que la scène puisse être restaurée depuis celui-ci.\nCela augmentera la taille du fichier exporté."
    },
    "title": {
      "exportToPng": "Exporter en PNG",
      "exportToSvg": "Exporter en SVG",
      "copyPngToClipboard": "Copier le PNG dans le presse-papier"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copier dans le presse-papier"
    }
  },
  "encrypted": {
    "tooltip": "Vos dessins sont chiffrés de bout en bout, les serveurs d'Excalidraw ne les verront jamais.",
    "link": "Article de blog sur le chiffrement de bout en bout dans Excalidraw"
  },
  "stats": {
    "angle": "Angle",
    "shapes": "Formes",
    "height": "Hauteur",
    "scene": "Scène",
    "selected": "Sélection",
    "storage": "Stockage",
    "fullTitle": "Propriétés du canevas et des formes",
    "title": "Propriétés",
    "generalStats": "Général",
    "elementProperties": "Propriétés de la forme",
    "total": "Total",
    "version": "Version",
    "versionCopy": "Cliquer pour copier",
    "versionNotAvailable": "Version non disponible",
    "width": "Largeur"
  },
  "toast": {
    "copyStyles": "Styles copiés.",
    "copyToClipboard": "Copié dans le presse-papier.",
    "copyToClipboardAsPng": "{{exportSelection}} copié dans le presse-papier en PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} copié dans le presse-papier en SVG\n({{exportColorScheme}})",
    "fileSaved": "Fichier enregistré.",
    "fileSavedToFilename": "Enregistré sous {filename}",
    "canvas": "canevas",
    "selection": "sélection",
    "pasteAsSingleElement": "Utiliser {{shortcut}} pour coller comme un seul élément,\nou coller dans un éditeur de texte existant",
    "unableToEmbed": "Intégrer cet URL n'est actuellement pas autorisé. Ouvrez un ticket sur GitHub pour demander son ajout à la liste blanche",
    "unrecognizedLinkFormat": "Le lien que vous avez intégré ne correspond pas au format attendu. Veuillez essayer de coller la chaîne d'intégration fournie par le site source",
    "elementLinkCopied": "Lien copié dans le presse-papiers"
  },
  "colors": {
    "transparent": "Transparent",
    "black": "Noir",
    "white": "Blanc",
    "red": "Rouge",
    "pink": "Rose",
    "grape": "Mauve",
    "violet": "Violet",
    "gray": "Gris",
    "blue": "Bleu",
    "cyan": "Cyan",
    "teal": "Turquoise",
    "green": "Vert",
    "yellow": "Jaune",
    "orange": "Orange",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Vos dessins sont enregistrés dans le stockage de votre navigateur.",
      "center_heading_line2": "Le stockage du navigateur peut être effacé de manière inattendue.",
      "center_heading_line3": "Enregistrez régulièrement votre travail dans un fichier pour éviter de le perdre.",
      "center_heading_plus": "Vouliez-vous plutôt aller à Excalidraw+ à la place ?",
      "menuHint": "Exportation, préférences, langues, ..."
    },
    "defaults": {
      "menuHint": "Exportation, préférences et plus...",
      "center_heading": "Diagrammes. Rendus. Simples.",
      "toolbarHint": "Choisissez un outil et commencez à dessiner !",
      "helpHint": "Raccourcis et aide"
    }
  },
  "colorPicker": {
    "color": "Couleur ",
    "mostUsedCustomColors": "Couleurs personnalisées les plus fréquemment utilisées",
    "colors": "Couleurs",
    "shades": "Nuances",
    "hexCode": "Code hex",
    "noShades": "Aucune nuance disponible pour cette couleur",
    "invalidColor": "Pas une couleur valide",
    "invalidHexLength": "Le code hexadécimal doit être de 3, 4, 6 ou 8 caractères",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exporter en image",
        "button": "Exporter en image",
        "description": "Exporter les données de la scène comme une image que vous pourrez importer ultérieurement."
      },
      "saveToDisk": {
        "title": "Sauvegarder sur le disque",
        "button": "Sauvegarder sur le disque",
        "description": "Exporter les données de la scène comme un fichier que vous pourrez importer ultérieurement."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exporter vers Excalidraw+",
        "description": "Enregistrer la scène dans votre espace de travail Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Charger depuis un fichier",
        "button": "Charger depuis un fichier",
        "description": "Charger depuis un fichier va <bold>remplacer votre contenu existant</bold>.<br></br>Vous pouvez d'abord sauvegarder votre dessin en utilisant l'une des options ci-dessous."
      },
      "shareableLink": {
        "title": "Charger depuis un lien",
        "button": "Remplacer mon contenu",
        "description": "Charger un dessin externe va <bold>remplacer votre contenu existant</bold>.<br></br>Vous pouvez d'abord sauvegarder votre dessin en utilisant l'une des options ci-dessous."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Recherche rapide"
  },
  "fontList": {
    "badge": {
      "old": "ancien"
    },
    "sceneFonts": "Dans cette scène",
    "availableFonts": "Polices disponibles",
    "empty": "Aucune police trouvée"
  },
  "userList": {
    "empty": "Aucun utilisateurs trouvé",
    "hint": {
      "text": "Cliquez sur l'utilisateur pour le suivre",
      "followStatus": "Vous suivez actuellement cet utilisateur",
      "inCall": "L'utilisateur est dans un appel vocal",
      "micMuted": "Le micro de l'utilisateur est muet",
      "isSpeaking": "L'utilisateur parle"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Option",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Échap",
    "enter": "Entrée",
    "shift": "Maj",
    "spacebar": "Espace",
    "delete": "Supprimer",
    "mmb": "Clic molette"
  }
}
